// extracted by mini-css-extract-plugin
export default {"mainChart":"Skeleton-module__mainChart__YBmuOTh","title":"Skeleton-module__title__Q92D48D","subtitle":"Skeleton-module__subtitle__saSKRDn"};